import { makeStyles } from '@material-ui/core/styles'
import { themeCommon } from '../../theme'

const useStyles = makeStyles((theme) => ({
    rootGridContain: {
        [theme.breakpoints.down('sm')]: {
            padding: '0 20px !important',
        },
        [theme.breakpoints.down('xs')]: {
            padding: '0 15px !important',
        },
    },
    layoutHeader: {
        marginBottom: '20px',
    },
    rootGridNewsHeader: {
        marginBottom: '0',
    },
    rootGridBreadcrumbs: {
        marginLeft: '20px',
    },
    rootTextField: {
        background: 'white',
        borderRadius: '4px',
        width: '500px',
        [theme.breakpoints.down('md')]: {
            width: '450px',
            height: '45px',
            '& > label': {
                fontSize: themeCommon.fontSize16px,
                marginTop: '-5px',
            },
            '& > div': {
                height: '45px',
            }
        },
        [theme.breakpoints.down('sm')]: {
            width: '350px',
            height: '40px',
            '& > label': {
                fontSize: themeCommon.fontSize14px,
                marginTop: '-5px',
            },
            '& > div': {
                height: '40px',
            }
        },
        [theme.breakpoints.down('xs')]: {
            height: '30px',
            width: '300px',
            '& > label': {
                fontSize: themeCommon.fontSize12px,
                marginTop: '-10px',
            },
            '& > div': {
                height: '30px',
            }
        },
    },
    rootTypography: {
        fontSize: themeCommon.fontSize26px,
        fontFamily: themeCommon.RobotoBold,
        margin: '20px 20px 20px',
        [theme.breakpoints.down('md')]: {
            fontSize: themeCommon.fontSize24px,
            margin: '20px 20px 20px',
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: themeCommon.fontSize22px,
            margin: '15px 15px 15px',
        },
        [theme.breakpoints.down('xs')]: {
            fontSize: themeCommon.fontSize20px,
            margin: '10px 10px 10px',
        },
    },
    rootGridSearch: {
        height: '65ch !important',
        [theme.breakpoints.down('md')]: {
            height: 'unset',
        },
        [theme.breakpoints.down('sm')]: {
            height: 'unset',
        },
        [theme.breakpoints.down('xs')]: {
            height: 'unset',
        },
    },
    pagination: {
        marginTop: '20px',
        '& > li:first-child > button': {
            border: 'none !important',
        },
        '& > li:last-child > button': {
            border: 'none !important',
        },
    },
}), {
    name: 'NewsHead',
    index: 1,
})

export default useStyles